import { Box, Chip } from '@mui/material';
import { Text } from '@qwickapps/react-framework';

interface ToolUsageStatsProps {
  toolCalls?: { name: string; count: number }[];
  totalToolCalls?: number;
}

export default function ToolUsageStats({ toolCalls, totalToolCalls }: ToolUsageStatsProps) {
  if ((!toolCalls || toolCalls.length === 0) && (!totalToolCalls || totalToolCalls === 0)) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Text variant="caption" style={{ fontWeight: 'bold', display: 'block', marginBottom: 4, opacity: 0.7 }}>
        Tool Usage
      </Text>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {totalToolCalls !== undefined && totalToolCalls > 0 && (
          <Chip
            label={`Total: ${totalToolCalls} tool ${totalToolCalls === 1 ? 'call' : 'calls'}`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              color: 'inherit',
            }}
          />
        )}
        {toolCalls && toolCalls.map((tool, idx) => (
          <Chip
            key={idx}
            label={`${tool.name}: ${tool.count}x`}
            size="small"
            sx={{
              fontSize: '0.75rem',
              bgcolor: 'rgba(255, 255, 255, 0.15)',
              color: 'inherit',
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
